import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0096aca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns w-100" }
const _hoisted_2 = { class: "column is-2" }
const _hoisted_3 = { class: "total-stations" }
const _hoisted_4 = { class: "column is-2" }
const _hoisted_5 = { class: "total-stations" }
const _hoisted_6 = { class: "column is-2" }
const _hoisted_7 = { class: "total-stations" }
const _hoisted_8 = { class: "column is-2" }
const _hoisted_9 = { class: "total-stations" }
const _hoisted_10 = { class: "column is-2" }
const _hoisted_11 = { class: "total-stations" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widget_indicator = _resolveComponent("widget-indicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_widget_indicator, {
        title: _ctx.$t('dispatch.gas_alarm_indicator.title'),
        description: _ctx.$t('dispatch.gas_alarm_indicator.description'),
        value: _ctx.gasCount,
        "active-color": "danger",
        colorClass: "has-text-success"
      }, {
        subvalue: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('widget_indicator_ok.n_station_out_of', { total : _ctx.stations?.length})), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title", "description", "value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_widget_indicator, {
        title: _ctx.$t('dispatch.trouble_alert_indicator.title'),
        description: _ctx.$t('dispatch.gas_alarm_indicator.description'),
        value: _ctx.troubleCount,
        "active-color": "danger",
        colorClass: "has-text-success"
      }, {
        subvalue: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('widget_indicator_ok.n_station_out_of', { total : _ctx.stations?.length})), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title", "description", "value"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_widget_indicator, {
        title: _ctx.$t('dispatch.offline_indicator.title'),
        description: _ctx.$t('dispatch.offline_indicator.description'),
        value: _ctx.offlineCount,
        "active-color": "danger",
        colorClass: "has-text-success"
      }, {
        subvalue: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('widget_indicator_ok.n_station_out_of', { total : _ctx.stations?.length})), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title", "description", "value"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_widget_indicator, {
        title: _ctx.$t('dispatch.ok_indicator.title'),
        description: _ctx.$t('dispatch.ok_indicator.description'),
        value: _ctx.okCount,
        "active-color": "danger",
        colorClass: "has-text-success"
      }, {
        subvalue: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('widget_indicator_ok.n_station_out_of', { total : _ctx.stations?.length})), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title", "description", "value"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_widget_indicator, {
        title: _ctx.$t('dispatch.stock_indicator.title'),
        description: _ctx.$t('dispatch.stock_indicator.description'),
        value: _ctx.storedCount,
        "active-color": "danger",
        colorClass: "has-text-success"
      }, {
        subvalue: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('widget_indicator_ok.n_station_out_of', { total : _ctx.stations?.length})), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title", "description", "value"])
    ])
  ]))
}